// ---
// Open Tab
// ---

const getOffsetTop = (element) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    // eslint-disable-next-line no-param-reassign
    element = element.offsetParent;
  }
  return offsetTop;
};

const tabItems = document.querySelectorAll('.tab-module__item');
const tabLinksParent = document.querySelectorAll('[data-tab-parent]');

const removeActiveClass = (element) => {
  element.forEach((item) => {
    if (item.querySelector('iframe.game-iframe') && item.classList.contains('is-active')) {
      const iframeBox = item.querySelector('iframe.game-iframe');
      if (iframeBox.src) {
        // eslint-disable-next-line no-self-assign
        iframeBox.src = iframeBox.src;
      }
    }
    if (item.querySelector('.sc-quiz-module') && item.classList.contains('is-active')) {
      item.querySelectorAll('.quiz-module__item').forEach((itemStep)=> {
        itemStep.classList.remove('is-active');
      });
      item.querySelector('.quiz-module__item').classList.add('is-active');
    }
    item.classList.remove('is-active');
  });
};

attachEvent('[data-tab]', 'click', (ev) => {
  const targetTab = ev.target.getAttribute('data-tab');
  const parentElem = ev.target.closest('.menu__item');
  removeActiveClass(tabItems);
  removeActiveClass(tabLinksParent);
  document.querySelector(`[data-tab-id="${targetTab}"]`).classList.add('is-active');
  parentElem.classList.add('is-active');
  document.body.scrollIntoView({ behavior: 'smooth' }, true);
  ev.preventDefault();
});
